var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import id from "@irati/utils/id";
import UserMenuDropdownOptions from "./UserMenuDropdownOptions";
import HeaderLink from "../shared/HeaderLink";
var MenuDropdown = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  margin-right: ", ";\n  ", "\n"], ["\n  position: relative;\n  margin-right: ", ";\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.one;
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.desktop(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme.spacing.two);
});
var StyledHeaderLink = styled(HeaderLink)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var HeaderMenu = /** @class */ (function (_super) {
    __extends(HeaderMenu, _super);
    function HeaderMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            show: false
        };
        _this.handleOutsideclick = function (_a) {
            var target = _a.target;
            if (!_this.container.contains(target)) {
                _this.hide();
            }
        };
        _this.show = function () {
            _this.setState({ show: true });
        };
        _this.hide = function () {
            _this.setState({ show: false });
        };
        _this.toggle = function () {
            _this.setState({ show: !_this.state.show });
        };
        return _this;
    }
    HeaderMenu.prototype.componentDidMount = function () {
        window.addEventListener("click", this.handleOutsideclick);
    };
    HeaderMenu.prototype.componentWillUnmount = function () {
        window.removeEventListener("click", this.handleOutsideclick);
    };
    HeaderMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, content = _a.content, tooltip = _a.tooltip;
        var show = this.state.show;
        var idNamespace = id("desktop", this.props);
        return (React.createElement(MenuDropdown, null,
            React.createElement("div", { id: idNamespace, ref: function (c) { _this.container = c; }, "data-attach-tooltip": tooltip },
                React.createElement(StyledHeaderLink, { id: id("menu-toggle", idNamespace), onClick: this.toggle }, children)),
            show && content &&
                React.createElement(UserMenuDropdownOptions, null, content)));
    };
    return HeaderMenu;
}(Component));
export default HeaderMenu;
var templateObject_1, templateObject_2, templateObject_3;
